import PublishedQuestionOptions, { PublishedQuestionOptionsProps } from './PublishedQuestionOptions';
import UnpublishedQuestionOptions, { UnpublishedQuestionOptionsProps } from './UnpublishedQuestionOptions';

export interface QuestionOptionsProps extends UnpublishedQuestionOptionsProps, PublishedQuestionOptionsProps {
  isPollPublished: boolean;
}

const QuestionOptions = ({
  isPollPublished,
  pollQuestion,
  formMethods,
  onSubmit,
  onLocalSubmit,
  className,
}: QuestionOptionsProps) => {
  if (isPollPublished) {
    return <PublishedQuestionOptions pollQuestion={pollQuestion} className={className} />;
  }

  return (
    <UnpublishedQuestionOptions
      formMethods={formMethods}
      onSubmit={onSubmit}
      onLocalSubmit={onLocalSubmit}
      className={className}
    />
  );
};

export default QuestionOptions;
